import Vue from 'vue'
import Vuex from 'vuex'

import assortment from './assortment.module'
import assortmentparameter from './assortmentparameter.module'
import auth from './auth.module'
import branches from './branches.module'
import clients from './clients.module'
import clusters from './clusters.module'
import nodes from './nodes.module'
import products from './products.module'
import sales from './sales.module'
import stock from './stock.module'
import users from './users.module'
import places from './places.module'
import simulations from './simulations.module'
import branchcomponent from './branchcomponent.module'
import branchparameter from './branchparameter.module'
import dccomponent from './dccomponent.module'
import dcparameter from './dcparameter.module'
import restocking from './restocking.module'
import solicitations from './solicitations.module'
import ranking from './ranking.module'
import tasks from './tasks.module'
import demands from './demands.module'
import stockRanking from './restocking_ranking/index'
import movements from './movements.module'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        assortment,
        assortmentparameter,
        auth,
        branches,
        clients,
        clusters,
        nodes,
        products,
        sales,
        stock,
        users,
        places,
        simulations,
        branchcomponent,
        branchparameter,
        dccomponent,
        dcparameter,
        restocking,
        solicitations,
        ranking,
        tasks,
        demands,
        stockRanking,
        movements
    }
})
